<template>
  <div>
    <v-snackbar
        v-model="snackbar.show"
        :color="snackbar.type"
        :multi-line="true"
        :timeout="5000" >
      {{ snackbar.message }}
    </v-snackbar>

    <CreditCardDialog v-if="showUpdateCcDialog" v-model="showUpdateCcDialog"></CreditCardDialog>

    <v-dialog v-model="showConfirmPurchaseDialog" scrollable :width="400">
      <LoadingDialog v-model="showLoadingDialog"></LoadingDialog>

      <v-card v-if="referenceBookCart">
        <v-card-title class="pa-0 mb-3" style="border-bottom: 4px solid #6D2E69;">
          <div class="add-on-heading">
            <div class="add-on-title txt-bold">Activate Subscription{{referenceBookCart.length > 1 ? 's' : null}}</div>
            <span flat icon color="itoviGrayMid" @click="$store.commit('setShowConfirmPurchaseDialog', false)"><v-icon>close</v-icon></span>
          </div>
        </v-card-title>
        <v-card-text class="pa-0">
          <div v-for="(addOn, index) in referenceBookCart" :key="`${index}-in-cart`"  class="mb-3">
            <v-layout align-center column>
              <v-flex class="mb-1 font-weight-bold itoviPurple--text" style="font-size: 18px">{{ addOn.name }}</v-flex>
              <v-flex class="font-weight-medium itoviPurple--text">${{ addOn.inCart === 'monthly' ? `${formatPrice(addOn.monthly)}/monthly` : `${formatPrice(addOn.yearly)}/yearly` }}</v-flex>
            </v-layout>
            <v-divider v-if="referenceBookCart.length - 1 > index" :key="`${index}-in-cart-divider`" class="mt-3"/>
          </div>
        </v-card-text>

        <v-divider class="mb-3"/>
        <v-layout class="mb-2" align-center column>
          <v-flex v-if="ccInfo && ccInfo.last_four">*Your card ending in <strong>{{ ccInfo.last_four }}</strong> will be charged</v-flex>
          <v-flex style="font-weight: bold" class="txt-button-blue" @click="$store.commit('setShowUpdateCcDialog', true)">
            {{ ccInfo && ccInfo.last_four ? "Update Card" : "Add Card" }}
          </v-flex>
        </v-layout>
        <div v-if="ccInfo.last_four" class="mb-3">
          <v-layout justify-center wrap class="mt-2">
            <button class="button-purple" @click="submitAddOnPurchase">Pay ${{ getTotalDue() }} Now</button>
          </v-layout>
        </div>
        <v-layout class="mb-3" align-center column>
          <v-flex>Price is prorated for month of purchase</v-flex>
        </v-layout>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import api from "../../../services/api_endpoints";
  import store from "../../../store";
  import { formatPrice } from "@/helpers/priceHelper";
  import LoadingDialog from "../../LoadingDialog";
  import CreditCardDialog from "../paymentInformationCard/CreditCardDialog";
  import subscribeToStore from "@/mixins/subscribeToStore";

  export default {
    components: {
      CreditCardDialog,
      LoadingDialog
    },
    mixins: [subscribeToStore],
    data: ()=> ({
      showLoadingDialog: false,
      showUpdateCcDialog: false,
      ccInfo: store.state.ccInfo,
      referenceBookCart: store.state.referenceBookCart,
      showConfirmPurchaseDialog: store.state.showConfirmPurchaseDialog,
      snackbar: {
        show: false,
        message: "An unknown error occurred",
        type: "error"
      }
    }),
    mounted() {
      this.subscribeToStore(['ccInfo', 'referenceBookCart', 'showConfirmPurchaseDialog']);
    },
    methods: {
      formatPrice,
      isFunction(functionToCheck) {
        return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
      },
      async submitAddOnPurchase() {
        this.showLoadingDialog = true;
        let response = await api.submitAddOnPurchase(this.referenceBookCart);
        this.showLoadingDialog = false;

        if (response.success) {
          await api.getPlanAddOns();
          this.$store.commit('setShowConfirmPurchaseDialog', false);
          this.$store.commit('setShowReferenceBooksDialog', false);
          this.$store.commit('setShowSuccessDialog', {active: true, message: `Congrats! Your subscription to ${this.getSuccessMessage()} is activated on your account!`});
          this.$store.commit('setReferenceBookCart',[]);
        } else {
          console.log(response);
          this.snackbar = {
            show: true,
            type: "error",
            message: response.errorMessage
          }
        }
        if (this.isFunction(this.onClose)) this.onClose(response.success)
      },
      async addPaymentMethod() {
        this.showUpdateCcDialog = true;
      },
      getTotalDue() {
        let totalDue = 0;
         this.referenceBookCart.forEach((addOn) => {
          if (addOn.inCart === 'annually') return  totalDue += parseFloat(addOn.yearly);
          totalDue += parseFloat(addOn.price);
        });
         return this.formatPrice(totalDue);
      },
      getSuccessMessage() {
        return this.referenceBookCart.map((addOn, index) => {
          if (this.referenceBookCart.length - 1 === index ) return `and ${addOn.name}`;
          return addOn.name;
        }).join(", ");
      }
    }
  }
</script>
